var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/cartIcon.2d4e7cd4.png","uri@2x": __webpack_public_path__ + "static/media/cartIcon.1f792e9d.png","uri@3x": __webpack_public_path__ + "static/media/cartIcon.7ec03e8d.png",
    width: 24,
    height: 24
});